/**
 * Reserved key for the quick-path generic counter (the bottom-left badge).
 * Named counters (e.g. "+1/+1", "loyalty") use their display name as key.
 */
export const GENERIC_COUNTER_KEY = '__generic__';
//# sourceMappingURL=playtester.js.map